<template>
  <div class="w-100">
    <div v-if="title" class="atom-select--title">
      {{ title
      }}<label v-if="isAsterisk" class="atom-select--asterisk">*</label>
    </div>
    <div class="atom-select__container">
      <b-form-group :state="state" class="mb-0">
        <v-select
          v-model="selectValue"
          :label="label"
          :options="option"
          :taggable="isPushTaggable"
          :push-tags="isPushTaggable ? isPushNewTagInOption : false"
          :placeholder="placeholder"
          :disabled="isDisable"
          :clearable="isClearable"
          :searchable="isSearchable"
          :append-to-body="isAppendToBody"
          :calculate-position="isEnableProper ? withPopper : () => undefined"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <feather-icon icon="ChevronDownIcon"
            /></span>
          </template>
        </v-select>
      </b-form-group>
      <div v-if="isError" class="error-message">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select"
import { BFormGroup } from "bootstrap-vue"
import { createPopper } from "@popperjs/core"

export default {
  name: "AtomSelect",
  components: {
    vSelect,
    BFormGroup,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    isAsterisk: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      // name of the key field that will show as an option in dropdowm.
      type: String,
      required: false,
      default: "label",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isError: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessage: {
      type: String,
      required: false,
      default: "",
    },
    isClearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSearchable: {
      type: Boolean,
      required: false,
      default: true,
    },
    option: {
      type: Array,
      required: true,
    },
    isEnableProper: {
      type: Boolean,
      required: false,
      default: true,
    },
    isAppendToBody: {
      type: Boolean,
      required: false,
      default: true,
    },
    isPushTaggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPushNewTagInOption: {
      type: Boolean,
      required: false,
      default: true,
    },
    value: {
      type: [String, Number, Array, Object, null],
      required: false,
      default: null,
    },
  },
  emits: ["input", "onUpdateSelectedValue", "change"],
  data() {
    return {
      placement: "top",
    }
  },
  computed: {
    selectValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
        this.$emit("change", value)
      },
    },
    state() {
      return this.isError && !this.isDisable ? !this.isError : true
    },
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.$emit("onUpdateSelectedValue")
      },
    },
  },
  methods: {
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              )
            },
          },
        ],
      })
      return () => popper.destroy()
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.atom-select__container::v-deep .vs__search::placeholder {
  padding-left: 0.35rem;
  color: #b9b9c3;
}

.vs__search::placeholder {
  color: #b9b9c3;
}

.vs__dropdown-toggle {
  background: white;
}

.vs__selected {
  color: #5e5873 !important;
  font-weight: 400;
}

.atom-select--title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}
.atom-select--asterisk {
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 0;
}

.error-message {
  margin-top: 4px;
  line-height: 1.5;
  font-size: 12px;
  color: #ea5455;
}
</style>
